var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSedes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.8187L4.25734 11.576C3.41823 10.7369 2.84679 9.66777 2.61529 8.50389C2.38378 7.34 2.5026 6.13361 2.95673 5.03726C3.41086 3.9409 4.1799 3.00384 5.16659 2.34455C6.15328 1.68527 7.31332 1.33337 8.5 1.33337C9.68669 1.33337 10.8467 1.68527 11.8334 2.34455C12.8201 3.00384 13.5891 3.9409 14.0433 5.03726C14.4974 6.13361 14.6162 7.34 14.3847 8.50389C14.1532 9.66777 13.5818 10.7369 12.7427 11.576L8.5 15.8187ZM11.8 10.6333C12.4526 9.98066 12.897 9.14914 13.077 8.2439C13.2571 7.33867 13.1646 6.40039 12.8114 5.54769C12.4582 4.695 11.86 3.96619 11.0926 3.45343C10.3252 2.94068 9.42296 2.66699 8.5 2.66699C7.57704 2.66699 6.67481 2.94068 5.90739 3.45343C5.13997 3.96619 4.54183 4.695 4.18861 5.54769C3.83539 6.40039 3.74294 7.33867 3.92297 8.2439C4.103 9.14914 4.54741 9.98066 5.2 10.6333L8.5 13.9333L11.8 10.6333ZM8.5 8.66665C8.14638 8.66665 7.80724 8.52618 7.55719 8.27613C7.30715 8.02608 7.16667 7.68694 7.16667 7.33332C7.16667 6.9797 7.30715 6.64056 7.55719 6.39051C7.80724 6.14046 8.14638 5.99999 8.5 5.99999C8.85362 5.99999 9.19276 6.14046 9.44281 6.39051C9.69286 6.64056 9.83334 6.9797 9.83334 7.33332C9.83334 7.68694 9.69286 8.02608 9.44281 8.27613C9.19276 8.52618 8.85362 8.66665 8.5 8.66665Z",
    fill: "#002856"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSedes);
export default __webpack_public_path__ + "static/media/sedes.2b535693d45fd7a6a7d26ec8507cf2e9.svg";
export { ForwardRef as ReactComponent };